"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var apollo_client_1 = require("apollo-client");

var async_1 = require("@shopify/async");

var react_async_1 = require("@shopify/react-async");

var hooks_1 = require("./hooks");

var Prefetch_1 = require("./Prefetch");

var Query_1 = require("./Query");

function createAsyncQueryComponent(_a) {
  var id = _a.id,
      load = _a.load,
      defer = _a.defer;
  var resolvedDocument = react_async_1.trySynchronousResolve({
    id: id,
    defer: defer
  });

  function resolve() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var response;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , react_async_1.resolve(load)];

          case 1:
            response = _a.sent();
            resolvedDocument = response;
            return [2
            /*return*/
            , response];
        }
      });
    });
  }

  function AsyncQuery(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    var client = hooks_1.useApolloClient();
    return React.createElement(react_async_1.Async, tslib_1.__assign({
      id: id,
      load: load,
      defer: defer,
      render: function render(query) {
        return query ? React.createElement(Query_1.Query, tslib_1.__assign({
          query: query
        }, componentProps)) : componentProps.children({
          data: undefined,
          loading: true,
          variables: componentProps.variables,
          client: client,
          networkStatus: apollo_client_1.NetworkStatus.loading,
          refetch: noop,
          fetchMore: noop,
          updateQuery: noop,
          startPolling: noop,
          stopPolling: noop,
          subscribeToMore: noop
        });
      }
    }, asyncProps));
  }

  function Prefetch(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    var variables = componentProps.variables;
    return React.createElement(react_async_1.Async, tslib_1.__assign({
      load: load,
      defer: async_1.DeferTiming.Mount,
      render: function render(query) {
        return query ? React.createElement(Prefetch_1.Prefetch, {
          ignoreCache: true,
          query: query,
          variables: variables
        }) : null;
      }
    }, asyncProps));
  }

  function Preload(props) {
    var asyncProps = splitProps(props)[1];
    return React.createElement(react_async_1.Async, tslib_1.__assign({
      defer: async_1.DeferTiming.Idle,
      load: load,
      id: id
    }, asyncProps));
  }

  function KeepFresh(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    var variables = componentProps.variables,
        _b = componentProps.pollInterval,
        pollInterval = _b === void 0 ? 10000 : _b;
    return React.createElement(react_async_1.Async, tslib_1.__assign({
      load: load,
      defer: async_1.DeferTiming.Idle,
      render: function render(query) {
        return query ? React.createElement(Prefetch_1.Prefetch, {
          query: query,
          pollInterval: pollInterval,
          variables: variables
        }) : null;
      }
    }, asyncProps));
  } // Once we upgrade past TS 3.1, this will no longer be necessary,
  // because you can statically assign values to functions and TS
  // will know to augment its type


  var FinalComponent = AsyncQuery;
  FinalComponent.Preload = Preload;
  FinalComponent.Prefetch = Prefetch;
  FinalComponent.KeepFresh = KeepFresh;
  FinalComponent.resolve = resolve;
  Object.defineProperty(FinalComponent, 'resolved', {
    get: function get() {
      return resolvedDocument;
    }
  });
  Object.defineProperty(FinalComponent, 'id', {
    get: function get() {
      return id && id();
    }
  });
  return FinalComponent;
}

exports.createAsyncQueryComponent = createAsyncQueryComponent;

function noop() {}

function splitProps(props) {
  var _a = props,
      async = _a.async,
      rest = tslib_1.__rest(_a, ["async"]);

  return [rest, async];
}